import ads from './ads'
import embed from "./social-media/embed";
import OneSignal from "./one-signal";
import Recaptcha from "./social-media/recaptcha";

const domEvents = {}

const initialize = () => {
    new OneSignal();
    embed.init();
    new Recaptcha();
}

const bindEvents = () => {
    document.addEventListener("DOMContentLoaded", function () {
        initialize();
    });

    document.addEventListener('show_banners', function () {
        ads.init();
    });

    document.addEventListener('no_show_banners', function () {
        ads.remove();
    });

    // More events should be here
}

domEvents.init = () => {
    bindEvents();
}

export default domEvents